import React, { Component } from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';


const styles = theme => ({
	button: {
		margin: theme.spacing.unit,
		display:'inline-block',
		color:"#FFFFFF"
	},
	closeIcon:{
		position:'absolute',
		top:10,
		right:10
	},
	cards:{
		position:'absolute',
		top:'50%',
		left:'50%',
		transform:'translate(-50%,-50%)'
	},
	cardsContentsWrapper:{

	},
	cardsContents:{
		overflowY:'scroll',
		overflowX:'hidden',
		width:'100%',
		marginTop:20
	},
	cardsAction:{
		position:'absolute',
		bottom:0,
		paddingBottom:20,
		paddingTop:20,
		width:'100%',
		borderTop:'rgba(0,0,0,0.1) solid 1px'
	},
	cardsActionButton:{
		textAlign:'center'
	},
	categories: {
		fontSize: '80%',
		color: '#000000',
		border: '#000000 solid 1px;',
		paddingLeft: 10,
		paddingRight: 10,
		marginLeft: 15,
		verticalAlign: 'text-top'
	}
});

class detailViewer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isClose:false
		}
	}

	handleClose = () => {
		if(this.props.afterCloseFunc) this.props.afterCloseFunc();
	};
	handleClickBefore = () => {
		if(this.props.clickBeforeFunc) this.props.clickBeforeFunc();
	};
	handleClickNext = () => {
		if(this.props.clickNextFunc) this.props.clickNextFunc();
	};


	
	render() {
		const {classes,title,date,contents,cat,hasBefore,hasNext} = this.props;
		const height = (this.props.navigation.windowHeight * 0.95) - 40;
		const width = (this.props.navigation.windowWidth * 0.9) - 120;
		const contentsHeight = height - 200;

		return (
			<div className="over_rays">
				<div className={classes.closeIcon}>
					<IconButton color={"primary"} className={classes.button} aria-label="CLOSE"
								onClick={this.handleClose}>
						<CloseIcon/>
					</IconButton>
				</div>

				<Card className={classes.cards} style={{height,width}}>
					<CardContent className={classes.cardsContentsWrapper}>
						<Typography className={classes.title} color="textSecondary" gutterBottom>
							{date}
							<span className={classes.categories}>
								{cat}
							</span>
						</Typography>
						<Typography variant="h5" component="h3">
							{title}
						</Typography>
						<div
							className={classNames("information_detail_contents",classes.cardsContents)}
							style={{height:contentsHeight}}
							dangerouslySetInnerHTML={{
								__html:contents
							}}
						/>
					</CardContent>
					<CardActions className={classes.cardsAction}>
						<Button className={classes.cardsActionButton} color={"primary"} size="medium" onClick={this.handleClickNext} disabled={!hasNext}>前のお知らせ</Button>
						<Button className={classes.cardsActionButton} color={"primary"} size="medium" onClick={this.handleClickBefore} disabled={!hasBefore}>次のお知らせ</Button>
					</CardActions>
				</Card>
			</div>
		);
	}
}
detailViewer.propTypes = {
	title:PropTypes.string,
	date:PropTypes.string,
	cat:PropTypes.string,
	contents:PropTypes.string,
	afterCloseFunc:PropTypes.func,
	clickBeforeFunc:PropTypes.func,
	clickNextFunc:PropTypes.func,
	hasBefore:PropTypes.bool,
	hasNext:PropTypes.bool,
};
function mapStateToProps(state) {
	return {
		navigation : state.navigation
	};
}
export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(detailViewer);


// WEBPACK FOOTER //
// ./src/routes/information/components/detail-viewer.js